import { Heading } from '@slal/ui/typography';
import { uniqueId } from 'lodash';
import { LinkProps } from 'react-router';
import { CardContent, CardHeader, NavigationIcon, StyledLink } from './styles';

export const NavigationCard = ({ heading, children, ...otherProps }: LinkProps & { heading: string }) => {
    const id = uniqueId('navigation-card-');

    return (
        <StyledLink aria-labelledby={id} {...otherProps}>
            <CardHeader>
                <Heading level={5} id={id}>
                    {heading}
                </Heading>
                <NavigationIcon />
            </CardHeader>
            <CardContent>{children}</CardContent>
        </StyledLink>
    );
};
